import { useSuspenseQuery } from "@tanstack/react-query"
import { trpc } from "app/trpc"

export const useUserGroups = () => {
  const { data: groups } = useSuspenseQuery(
    trpc.users.getUserGroups.queryOptions()
  )
  return groups
}
